// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"273":"8c21362c","527":"de700957"}[chunkId] + ".chunk.css";
};